export default __webpack_public_path__ + "static/media/map.ee54396a.png";